import * as React from "react";

/** value -> the item's children, so the trigger shows an item's label rather
 *  than its raw value before the popup has ever mounted. */
export const SelectLabelMapContext = React.createContext<Map<
  string,
  React.ReactNode
> | null>(null);

export function buildSelectLabelMap(
  children: React.ReactNode,
  itemType: unknown,
): Map<string, React.ReactNode> {
  const map = new Map<string, React.ReactNode>();
  const walk = (node: React.ReactNode): void => {
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }
    if (!React.isValidElement(node)) return;
    const props = node.props as { value?: unknown; children?: React.ReactNode };
    if (node.type === itemType && typeof props.value === "string") {
      map.set(props.value, props.children ?? null);
    }
    if (props.children !== undefined) walk(props.children);
  };
  walk(children);
  return map;
}
